var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Box',[_c('Row',[_c('Column',{attrs:{"width":15}},[(!_vm.isLoading)?_c('Compliance'):_vm._e()],1)],1),(_vm.isLoading)?_c('LoadingRow',{attrs:{"showBorder":true}},[_vm._v(_vm._s(_vm.loadingMessage))]):_vm._e(),(_vm.isLoading)?_c('SpacerRow'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }